import { DOCUMENT } from '@angular/common';
import {
    AfterViewInit,
    Component,
    ElementRef,
    Inject,
    Renderer2,
    ViewChild
} from '@angular/core';
import { Router, NavigationStart, NavigationEnd, NavigationError } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { AuthenticationService } from '../shared/authentication/authentication.service';
import { TokenService } from '../shared/authentication/token.service';
import { BaseComponent } from '../shared/components/component-base';
import { LoaderService } from '../shared/services/loader.service';
declare let bootstrap: any; 

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent extends BaseComponent implements AfterViewInit {
  @ViewChild('myTable') myTable!: ElementRef<HTMLTableElement>;

  _currentCultureKey: string = "lang";
  isUserAuthenticated: boolean = false;
  @ViewChild('mainContainer') mainContainer: ElementRef;
  isMenuVisible = false; // Track the menu state

  constructor(
    private elementRef: ElementRef,
    public _tokenService: TokenService,
    public _authenticationService: AuthenticationService,
    public translate: TranslateService,
    private renderer: Renderer2,
    private el: ElementRef,
    @Inject(DOCUMENT) private _document,
    private router: Router,
    private loaderService: LoaderService
  ) {
    super();

    this.setDefaultLanguage();
    this.setDocumentDirection();
    this.setupRouterEvents();
  }

  ngOnInit() {
    this.isUserAuthenticated = this.authService.isUserAuthenticated()
    this.elementRef.nativeElement.removeAttribute('ng-version');
  }

  private setupRouterEvents() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.loaderService.show();
      } else if (event instanceof NavigationEnd || event instanceof NavigationError) {
        this.loaderService.hide();
      }
    });
  }


  ngAfterViewInit() {
    setTimeout(() =>this.initOnLoad(), 2000);
  }

  initOnLoad() {
    this.initTooltips();
    //this.renderScripts();
  }

  renderScripts() {
    const generalScript = this.renderer.createElement('script');
    generalScript.type = 'text/javascript';
    generalScript.src = '/assets/js/script.js';
    this.renderer.appendChild(this._document.body, generalScript);
  }

  private initTooltips() {
    const tooltipTriggerList = this.el.nativeElement.querySelectorAll('[data-bs-toggle="tooltip"]');
    if (tooltipTriggerList.length) {
      tooltipTriggerList.forEach((tooltipTriggerEl: any) => new bootstrap.Tooltip(tooltipTriggerEl));
    }
  }

  setDocumentDirection() {
    if (this.translate.getDefaultLang() == 'ar')
      document.dir = 'rtl';
    else
      document.dir = 'ltr';
  }

  setDefaultLanguage() {
    let defaultLanguage = environment.defaultLanguage;
    let supportedLanguages = environment.supportedLanguages;
    this.translate.addLangs(supportedLanguages);

    if (localStorage.getItem(this._currentCultureKey) != null) {
      this.translate.setDefaultLang(localStorage[this._currentCultureKey]);
    } else {
      // This language will be used as a fallback when a translation isn't found in the current language
      this.translate.setDefaultLang(defaultLanguage);
      localStorage.setItem(
        this._currentCultureKey,
        this.translate.getDefaultLang()
      );
    }

    // Set application default language.
    this.translate.use(this.translate.getDefaultLang());
  }

  toggleMenu() {
    this.isMenuVisible = !this.isMenuVisible;

  }


}
